module.exports = __webpack_public_path__ + "img/d401594.png";